import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-grok',
  templateUrl: './grok.component.html',
  styleUrls: ['./grok.component.scss']
})
export class GrokComponent {
  constructor(public dialogRef: MatDialogRef<GrokComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
